import v12Schema, {
  MigrationTypes as V12Types,
} from "../client/schemaVersions/v12.js";
import v13Schema, {
  MigrationTypes as V13Types,
} from "../client/schemaVersions/v13.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V12Types, V13Types>(
  v12Schema,
  v13Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
